module.exports = __webpack_public_path__ + "img/13.e0d8c400.png";